// removed by extract-text-webpack-plugin
module.exports = {"root":"terms-and-conditions--root--VmRB3_VM"};


//////////////////
// WEBPACK FOOTER
// ./views/terms-and-conditions/styles.css
// module id = ./views/terms-and-conditions/styles.css
// module chunks = 0